module.exports = __webpack_public_path__ + "img/calendar3-week-fill.f37570e4.svg";